import React from "react";
import "./Footer.scss";

const Footer = () => {
	return (
		<footer className="footer">
			<p>© 2026 jardulik. Панель модерации.</p>
		</footer>
	);
};

export default Footer;
